import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { catchError, finalize, of, switchMap, tap } from 'rxjs';
import { SkeletonComponent } from 'src/app/components/skeleton/skeleton.component';
import { SummaryTableComponent } from 'src/app/components/summary-table/summary-table.component';
import { Summary } from 'src/app/models/summary.model';
import { LoggingService } from 'src/app/services/logging.service';
import { OrganizationsService } from 'src/app/services/organizations.service';

@Component({
  selector: 'app-details',
  standalone: true,
  imports: [SummaryTableComponent, SkeletonComponent],
  templateUrl: './details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsComponent implements OnInit {
  public ngOnInit(): void {
    of(null)
      .pipe(
        tap(() => this.loading.update(() => true)),
        switchMap(() => this.organizationsService.fetchSummary()),
        catchError((error) => {
          this.logger.error({ message: $localize`Fetch summary error`, error });

          return of(null);
        }),
        finalize(() => this.loading.update(() => false)),
      )
      .subscribe((summary) => this.summary.set(summary));
  }

  private readonly organizationsService = inject(OrganizationsService);
  private readonly logger = inject(LoggingService);

  public loading = signal<boolean>(false);
  public summary = signal<Summary | null>(null);
}
